import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { apiError } from "../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import ComparisonView from "../components/ComparisonView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmployeeComparison() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [locked, setLocked] = useState(false);

  const load = () => axios.get(`${API}/public/calibrations/${token}/comparison`).then((r) => setData(r.data)).catch((e) => {
    if (e.response?.status === 403) setLocked(true);
    else toast.error(apiError(e, "Failed to load"));
  });

  useEffect(() => { load(); }, [token]);

  if (locked) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="cal-card p-10 text-center relative overflow-hidden">
          <div className="locked-pattern" />
          <Lock className="mx-auto mb-4" size={40} />
          <h2 className="font-display font-bold text-3xl mb-2">Not yet unlocked</h2>
          <p className="text-[#666] mb-6">Your manager hasn't submitted their rating yet. Come back to this link soon.</p>
          <Link to={`/e/${token}`} className="cal-btn" data-testid="locked-back">← Back</Link>
        </div>
      </div>
    );
  }
  if (!data) return <div className="p-10 font-mono-cal text-xs">[LOADING…]</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-12">
      <div className="flex items-center gap-3 mb-10">
        <div className="h-7 w-7 border border-[#111] flex items-center justify-center">
          <div className="h-3 w-3 bg-[#FF4F00]" />
        </div>
        <span className="font-display font-bold text-xl tracking-tight">CALIBRATE</span>
        <span className="ml-auto font-mono-cal text-[10px] uppercase tracking-widest text-[#666]">[SECURE LINK]</span>
      </div>
      <ComparisonView data={data} />
      <div className="mt-10 flex justify-end">
        <Link to={`/e/${token}`} className="cal-btn cal-btn-ghost" data-testid="comparison-back">← Back</Link>
      </div>
    </div>
  );
}
